import type { Nullable } from "../types";
import { cleanString } from "./clean-string";

/**
 * This function converts a string into a slug format.
 * It replaces spaces with hyphens, removes special characters,
 * and converts the string to lowercase.
 *
 * @example
 * slugString("Hello World! This is a test.") // "hello-world-this-is-a-test"
 * @param input
 * @returns
 */
export function slugString(input: Nullable<string>): string {
	if (!input) return "";
	if (typeof input !== "string") return "";
	const segments = input.trim().split(" ");
	return segments.map(cleanString).join("-").replace(/-+/g, "-");
}
